module.exports = __webpack_public_path__ + "static/media/mental-red.94e4e083.svg";